import { Stack, Text, VStack } from '@genial/components';
import React from 'react';

import { RiskRating } from '../../../../../../../../../../components/RiskRating';
import { RiskSkeleton } from '../../../../../AssetsLoading';
import { FixedIncomeSharedInfoTypes, FixedIncomeSharedInfoTypesLoading } from '../types';

export const RiskInfo: React.FC<FixedIncomeSharedInfoTypes> = ({ offer, w }) => {
  return (
    <Stack w={w}>
      <VStack space="stack.quarck" justifyContent="space-between">
        <Text variant="semibold">Risco</Text>
        <RiskRating
          currentRiskRating={Number(offer.riskRatingLevelNormalized) || 0}
          tooltip={offer.riskRatingName || ''}
        />
      </VStack>
    </Stack>
  );
};

export const RiskInfoLoading: React.FC<FixedIncomeSharedInfoTypesLoading> = ({ w }) => {
  return (
    <Stack w={w}>
      <VStack space="stack.quarck" justifyContent="space-between">
        <Text variant="semibold">Risco</Text>
        <RiskSkeleton />
      </VStack>
    </Stack>
  );
};
